export const getDoNotTrackStatus = (): boolean => {
  if (typeof window === "undefined") return false;

  const dnt =
    navigator.doNotTrack ||
    (window as any).doNotTrack ||
    (navigator as any).msDoNotTrack;

  return dnt === "1" || dnt === "yes";
};

export const initializeAnalytics = (consent: boolean) => {
  if (typeof window === "undefined") return;

  const doNotTrack = getDoNotTrackStatus();
  if (doNotTrack) return;
  console.log("here", consent);

  if (consent) {
    // Initialize Google Analytics
    const gtagScript = document.createElement("script");
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_ANALYTICS_ID}`;
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    });

    // Initialize Microsoft Clarity
    const clarityScript = document.createElement("script");
    clarityScript.text = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_CLARITY_ID}");
      `;
    document.head.appendChild(clarityScript);
  }
};

const STORAGE_KEY = "landing_utm";

/**
 * Get stored UTM parameters from sessionStorage
 */
export function getStoredUtms(): Record<string, string> | null {
  if (typeof window === "undefined") return null;

  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error("Failed to retrieve UTM parameters:", error);
    return null;
  }
}

/**
 * Append UTM parameters to a URL
 */
export function appendUtmsToUrl(url: string): string {
  const utms = getStoredUtms();
  if (!utms) return url;

  try {
    const urlObj = new URL(url, window.location.origin);
    Object.entries(utms).forEach(([key, value]) => {
      urlObj.searchParams.set(key, value);
    });
    return urlObj.toString();
  } catch (error) {
    console.error("Failed to append UTMs to URL:", error);
    return url;
  }
}

/**
 * Send a Google Analytics event
 */
export const sendGAEvent = (
  action: string,
  category: string,
  label: string,
  value?: number
) => {
  if (typeof window !== "undefined" && (window as any).gtag) {
    console.log("Sending GA event", action, category, label, value);
    (window as any).gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
